// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class GetCaseRequestModel {
    static getAttributeTypeMap() {
        return GetCaseRequestModel.attributeTypeMap;
    }
}
GetCaseRequestModel.discriminator = undefined;
GetCaseRequestModel.additionalProperties = false;
GetCaseRequestModel.attributeTypeMap = [
    {
        "name": "caseId",
        "baseName": "caseId",
        "type": "number"
    },
    {
        "name": "includeDiagnoses",
        "baseName": "includeDiagnoses",
        "type": "boolean"
    },
    {
        "name": "includePayors",
        "baseName": "includePayors",
        "type": "boolean"
    },
    {
        "name": "includePharmacies",
        "baseName": "includePharmacies",
        "type": "boolean"
    },
    {
        "name": "includePrescribers",
        "baseName": "includePrescribers",
        "type": "boolean"
    },
    {
        "name": "includePrescriptions",
        "baseName": "includePrescriptions",
        "type": "boolean"
    },
    {
        "name": "includeSites",
        "baseName": "includeSites",
        "type": "boolean"
    },
    {
        "name": "includeSurveys",
        "baseName": "includeSurveys",
        "type": "boolean"
    },
];
//# sourceMappingURL=getCaseRequestModel.js.map